
import Vue from 'vue'

export default Vue.extend({
   name: 'ToastComponent',
   props: {
      toast: Object as () => IToast,
   },
   computed: {
      toastClass(): string {
         return !!this.toast ? `toast-${this.toast.type}` : ''
      },

      toastTitle(): string {
         return !!this.toast && !!this.toast.title ? this.toast.title : ''
      },

      hasToastTitle(): boolean {
         return !!this.toast && !!this.toast.title && this.toast.title.trim().length > 0
      },

      toastMessage(): string {
         return !!this.toast && !!this.toast.message ? this.toast.message : ''
      },

      hasCloseButton(): boolean {
         return !!this.toast && this.toast.hideCloseButton !== true
      },
   },
})
